import {FormsySchema, SocialSchemaKeys} from '.';

const getSocialSchema = (getMessage, messages): FormsySchema<SocialSchemaKeys> => ({
    mainChannelPlatform: {
        identifier: 'mainChannelPlatform',
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            )
        }
    }
});

export default getSocialSchema;
